/**
 * One rule for how an absent value reads across the client record (bug 5840).
 *
 * The same missing employee count rendered four different ways on one client — "Employees TBD" in
 * the banner, "—" on Details and in the SOP, and "0" in the SOP site table. The em dash is the
 * convention the SOP builder and the covering email already use (OnboardingSopBuilder.EmptyValue),
 * so it is the one kept here rather than a fifth spelling.
 */
export const EMPTY_VALUE = "—";

/** True only for "nothing was captured" — a real zero is a captured value, not an absence. */
export const isAbsent = (value: unknown): boolean =>
  value === null || value === undefined || value === "";

/**
 * The record banner's employee line.
 *
 * The previous form tested `totalStaff ?`, which is falsy for zero — so a client whose head count
 * really is 0 was reported as "Employees TBD", i.e. not captured. Absence and zero are different
 * facts and read differently.
 */
export const employeeCountText = (
  count: number | null | undefined,
): string => (isAbsent(count) ? `Employees ${EMPTY_VALUE}` : `${count} employees`);
